import React from 'react';

const DropdownArrow = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g fill={color}>
        <g>
          <g>
            <path
              d="M5.148 9.154c.176-.182.45-.203.647-.06l.07.06L12 15.514l6.135-6.36c.176-.182.449-.203.646-.06l.07.06c.176.182.196.465.06.67l-.06.073L12 17 5.148 9.897c-.197-.205-.197-.538 0-.743z"
              transform="translate(-1356 -746) translate(1189 746) translate(167)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default DropdownArrow;
